function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
app.views.registration = app.views.base.extend(_defineProperty(_defineProperty(_defineProperty({
  childEvents: {
    'click [data-show-password]': 'onShowRegistrationPasswordEventListener',
    'keyup [data-input]': 'onRegistrationFormFieldChangeEventListener',
    'focus [data-password]': 'showPasswordValidator',
    'blur [data-password]': 'hidePasswordValidator',
    'keyup [data-password]': 'validatePassword'
  },
  constants: {
    defaultError: 'Please correct error(s).'
  },
  attr: {
    form: 'data-form',
    input: 'data-input',
    submit: 'data-submit',
    message: 'data-message',
    error: 'data-error',
    spinner: 'data-spinner',
    accordion: 'data-accordion',
    accordionItem: 'data-accordion-item',
    passwordValidator: 'data-password-validator',
    passwordLength: 'data-password-length',
    passwordNumber: 'data-password-number',
    passwordUppercase: 'data-password-uppercase',
    passwordLowercse: 'data-password-lowercase',
    passwordSpecialCharacter: 'data-password-specialchar'
  },
  classes: {
    active: 'active',
    disabled: 'disabled',
    registrationError: 'registration-error',
    inputError: 'input-validation-error',
    fieldError: 'field-validation-error',
    fieldValid: 'field-validation-valid',
    checkIcon: 'fa-check-circle',
    invalidIcon: 'fa-minus-circle'
  },
  /**
   * Initialise Registration View Listener
   * @public
   * @constructor
   * @param {data} data : RegistrationViewModel
   */

  init: function init(data) {},
  onSuccessfulSubmission: function onSuccessfulSubmission(response) {
    if (response && response.nextRequestAjax === false) {
      $('[' + this.attr.spinner + ']').show();
      window.location = window.location.origin + response.redirectUrl;
    }
  },
  /**
   * Form Field Change Event Listener
   * Fires when the user enters or changes the information in the form fields.
   * @public
   * @param {event} e : event of the input field change.
   */

  onRegistrationFormFieldChangeEventListener: function onRegistrationFormFieldChangeEventListener(e) {
    var form = $('[' + this.attr.form + ']');
    var emptyFields = this._getEmptyFieldCount(form);
    var password = $('#CustomerPassword').val();
    var confirmPassword = $('#CustomerPasswordConfirmation').val();
    if (emptyFields > 0) {
      this._disableSubmissionAction();
    } else {
      if (password === confirmPassword) {
        this._enableSubmissionAction();
      } else {
        this._disableSubmissionAction();
      }
    }
    this._updateFormErrorState(e);
    if ($(e.currentTarget).is('[' + this.attr.dob + ']')) {
      this._validateDateOfBirth(e);
    }
  },
  /**
   * On Show Password Event Listener
   * Fires when the user click to show the password in visible text.
   * @public
   * @param {event} e : the event of the show action.
   */

  onShowRegistrationPasswordEventListener: function onShowRegistrationPasswordEventListener(e) {
    var input = $(e.currentTarget).parents('.input').find('[' + this.attr.input + ']');
    if (input.attr('type') === 'password') {
      $(e.currentTarget).html('Hide');
      input.attr('type', 'text');
    } else {
      $(e.currentTarget).html('Show');
      input.attr('type', 'password');
    }
  },
  /**
   * Update Submit Action State
   * Enables or disables the submit action based on the field state and wether the terms and conditions have been confirmed.
   * @private
   */

  _updateSubmitActionState: function _updateSubmitActionState() {
    var form = $('[' + this.attr.form + ']');
    var emptyFields = this._getEmptyFieldCount(form);
    if (emptyFields > 0) {
      this._disableSubmissionAction();
    } else {
      this._enableSubmissionAction();
    }
  },
  /**
   * Update Form Error State
   * Checks against all inputs within the form to see if the form error message is required.
   * @private
   * @param {event} e : the event of the input field change.
   */

  _updateFormErrorState: function _updateFormErrorState(e) {
    var _this = this;
    var form = $('[' + this.attr.form + ']');
    setTimeout(function () {
      var inputErrors = form.find('.' + _this.classes.inputError).length;
      var error = $(e.currentTarget).find('[' + _this.attr.error + ']');
      var formError = error.parents('.' + _this.classes.registrationError);
      if (inputErrors > 0) {
        error.html(_this.constants.defaultError);
        formError.show();
      } else {
        formError.hide();
      }
    }, 0);
  },
  /**
   * Get Empty Field Count
   * Returns the length of empty fields on the active authentication form.
   * @private
   * @param {element} form : the active authentication form.
   */

  _getEmptyFieldCount: function _getEmptyFieldCount(form) {
    var inputs = form.find('[' + this.attr.input + ']');
    var emptyFields = inputs.filter(function () {
      return this.value === ''; // Find all empty inputs within the form.
    });
    return emptyFields.length;
  },
  /**
   * Clear Input Values
   * Clears the values from all input fields.
   * @private
   * @param {element} forms : all authentication forms.
   */

  _clearInputValues: function _clearInputValues(forms) {
    forms.find('[' + this.attr.input + ']').each(function () {
      $(this).val('');
    });
  },
  /**
   * Clear Error Messages
   * Clears the form validation messages.
   * @private
   */

  _clearErrorMessages: function _clearErrorMessages() {
    var formError = $(form).find('.' + this.classes.registrationError);
    var inputError = $('.' + this.classes.inputError);
    var fieldError = $('.' + this.classes.fieldError);
    formError.hide();
    inputError.removeClass(this.classes.inputError);
    fieldError.removeClass(this.classes.fieldError);
    fieldError.addClass(this.classes.fieldValid);
  },
  /**
   * Enable Submit Action
   * Enables the form submit action allowing for the form to be submitted.
   * @private
   */

  _enableSubmissionAction: function _enableSubmissionAction() {
    var submit = $('[' + this.attr.submit + ']');
    submit.prop('disabled', false);
    submit.removeClass('btn--' + this.classes.disabled);
  },
  /**
   * Disable Submit Action
   * Disables the submit action blocking the form from being submitted.
   * @private
   */

  _disableSubmissionAction: function _disableSubmissionAction() {
    var submit = $('[' + this.attr.submit + ']');
    submit.prop('disabled', true);
    submit.addClass('btn--' + this.classes.disabled);
  },
  /**
   * Show Password Validator
   * Shows popup for password validation conditions
   * @public
   */
  showPasswordValidator: function showPasswordValidator() {
    $('[' + this.attr.passwordValidator + ']').show(500);
  },
  /**
   * Hide Password Validator
   * Hide popup for password validation conditions
   * @public
   */
  hidePasswordValidator: function hidePasswordValidator() {
    $('[' + this.attr.passwordValidator + ']').hide(500);
  },
  /**
   * Validate Password
   * Validate password to check of complexity requirements
   * @public
   */
  validatePassword: function validatePassword(e) {
    var lowerCase = new RegExp('[a-z]'),
      upperCase = new RegExp('[A-Z]'),
      numbers = new RegExp('[0-9]'),
      standardCharacters = new RegExp("^[a-zA-Z0-9]+$");
    var inputValue = $(e.currentTarget).val();
    this._updatePasswordValidatorIndicators(inputValue.match(lowerCase), this.attr.passwordLowercse);
    this._updatePasswordValidatorIndicators(inputValue.match(upperCase), this.attr.passwordUppercase);
    this._updatePasswordValidatorIndicators(inputValue.match(numbers), this.attr.passwordNumber);
    this._updatePasswordValidatorIndicators(!inputValue.match(standardCharacters), this.attr.passwordSpecialCharacter);
    this._updatePasswordValidatorIndicators(inputValue.length >= 10, this.attr.passwordLength);
    if (inputValue.match(lowerCase) && inputValue.match(upperCase) && inputValue.match(numbers) && !inputValue.match(standardCharacters) && inputValue.length >= 10) this.hidePasswordValidator();else this.showPasswordValidator();
  },
  _updatePasswordValidatorIndicators: function _updatePasswordValidatorIndicators(condition, element) {
    if (condition) {
      $('[' + element + ']').removeClass(this.classes.invalidIcon);
      $('[' + element + ']').addClass(this.classes.checkIcon);
    } else {
      $('[' + element + ']').removeClass(this.classes.checkIcon);
      $('[' + element + ']').addClass(this.classes.invalidIcon);
    }
  }
}, "_enableSubmissionAction", function _enableSubmissionAction() {
  var submit = $('[' + this.attr.submit + ']');
  submit.prop('disabled', false);
  submit.removeClass('btn--' + this.classes.disabled);
}), "_disableSubmissionAction", function _disableSubmissionAction() {
  var submit = $('[' + this.attr.submit + ']');
  submit.prop('disabled', true);
  submit.addClass('btn--' + this.classes.disabled);
}), "onShowPasswordEventListener", function onShowPasswordEventListener(e) {
  var input = $(e.currentTarget).parents('.input').find('[' + this.attr.input + ']');
  if (input.attr('type') === 'password') {
    $(e.currentTarget).html('Hide');
    input.attr('type', 'text');
  } else {
    $(e.currentTarget).html('Show');
    input.attr('type', 'password');
  }
}));